module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-blocks-blue-f344df3c9fd901ec1c73bf257e471229.svg";